import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=4b8fa152&scoped=true&"
import script from "./FilterSelector.vue?vue&type=script&lang=js&"
export * from "./FilterSelector.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelector.vue?vue&type=style&index=0&id=4b8fa152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fa152",
  null
  
)

export default component.exports